(function () {
    'use strict';

    angular.module('SMART2').service('formWidgetUtils', [function () {
        var _this = this;

        /*
         *  Get colspan class according to the number passed
         */
        this.getColspanClass = function (colspan) {
            switch (colspan) {
                case 1:
                    return 'col s12 m6 l4 xl3 xxl2';
                    break;
                case 2:
                    return 'col s12 m12 l8 xl6 xxl4';
                    break;
                case 3:
                    return 'col s12 m12 l12 xl9 xxl6';
                    break;
                case 4:
                    return 'col s12 m12 l12 xl12 xxl8';
                    break;
                case 5:
                    return 'col s12 m12 l12 xl12 xxl10';
                    break;
                case 6:
                    return 'col s12 m12 l12 xl12 xxl12';
                    break;
                case 7:
                    return 'col s12 m6 l4 xl4 xxl4';
                    break;
                case 8:
                    return 'col s12 m6 l6 xl6 xxl6 removeTruncate marginTop30';
                    break;
                case 9:
                    return 'col s12 m6 l4 xl3';
                    break;
                case 10:
                    return 'col s12 m6 l6 xl6 xxl6 removeTruncate marginTop30 datefield';
                    break;  
                case 11:
                    return 'col s12 m6 l6 xl6 xxl6 removeTruncate marginTop30 numberField';
                    break;   
                case 12:
                    return 'col s12  l4 xl3 xxl2';
                    break;
                case 13:
                    return 'col s12 m12 l9 xl6 xxl6';
                    break;    
                default:
                    return 'col s12 m6 l4 xl3 xxl2';
                    break;
            }
        };

        /*
         *  Convert value into actual scope variable/function and evaluate it
         */
        this.convertAndGetValue = function (val, scope, property) {
            if (val == '' || val == undefined || val == null) {
                return false;
            }
            var dataType;
            try {
                dataType = typeof eval(val);
            }
            catch (e) { }
            if (dataType == undefined) {
                //  If function
                if (val.indexOf(')') == val.length - 1) {
                    return eval(this.generateFunctionWithParams(val, 'scope.$parent'));
                }
                var result = eval('scope.$parent.' + val);
                dataType = typeof result;
                if (dataType == 'boolean') {
                    return result;
                }
                dataType = dataType == 'function' ? 'function' : 'string';
            }
            if (dataType == 'function') {
                return eval(this.generateFunctionWithParams(val, 'scope.$parent'));
            }
            else if (dataType == 'string') {
                return eval('scope.$parent.' + val);
            }
            else {
                return eval(val);
            }
        };

        /*
         *  Map events
         */
        this.mapEvents = function (arrEvents) {
            if (typeof arrEvents == 'object') {
                var str = '',
                    tLen = arrEvents.length;
                for (var i = 0; i < tLen; i++) {
                    var tObj = arrEvents[i];
                    if (tObj.listener) {
                        str = str + ' ' + tObj.type + '="' + tObj.listener + '"';
                    }
                }
                return str + ' ';
            }
            return '';
        };

        /*
         *  Generate params list from function name
         */
        this.getParamsFromEvents = function (event, scopeString) {
            var params = event.split('(');
            if (params.length > 1) {
                params = params[1].trim().split(')');
                params = params[0].split(',');
                var arrIndexesToBeDeleted = [],
                    tLen = params.length;
                for (var i = 0; i < tLen; i++) {
                    params[i] = params[i].trim();
                    if (params[i] != '$event') {
                        if (params[i] == '') {
                            arrIndexesToBeDeleted.push(params[i]);
                        }
                        else {
                            var paramValue = undefined;
                            try {
                                paramValue = eval(params[i]);
                            }
                            catch (e) { }
                            if (angular.isDefined(paramValue)) {
                                params[i] = params[i].trim();
                            }
                            else {
                                params[i] = (scopeString == '' || scopeString == undefined || scopeString == null ? '' : scopeString + '.') + params[i].trim();
                            }
                        }
                    }
                }
                var deleteLength = arrIndexesToBeDeleted.length;
                for (var i = 0; i < deleteLength; i++) {
                    params.splice(arrIndexesToBeDeleted[i], 1);
                }
            }
            else {
                params = [];
            }
            return params;
        };

        /*
         *  Convert function and its parameters into actual scope
         *  For e.g. onChange(modelData) would be converted into scopeString.onChange(scopeString.modelData)
         *  scopeString is the scope reference
         */
        this.generateFunctionWithParams = function (event, scopeString, isSection) {
            var functionName = '';
            if (!event) {
                return functionName;
            }
            var params = this.getParamsFromEvents(event, scopeString);
            functionName = (event.split('(')[0]).trim();
            if (params.length > 0) {
                params.push(isSection ? 'section' : 'property');
                functionName = scopeString + '.' + functionName + '(' + params.join(',') + ')';
            }
            else {
                functionName = scopeString + '.' + functionName + (isSection ? '(section)' : '(property)');
            }
            return functionName;
        };

        /*
         *  Convert attribute value into actual scope
         *  For e.g. isReqNameMandatory(modelData.reqName) would be converted into scope.isReqNameMandatory(scope.modelData.reqName)
         *  scope is the scope reference
         */
        this.convertAndGetAttributeMapping = function (attributeType, key, attr, bindingType, scope, isSection) {
            var str = attr + '="' + (bindingType == '@' ? '{{' : '') + (isSection ? 'section.' : (attributeType == 'primary' ? 'property.' : 'property.attributes.')) + key + (bindingType == '@' ? '}}' : '') + '"';
            var dataType;
            var objProperty;
            if (attributeType == 'primary' && isSection) {
                objProperty = scope.section;
            }
            else if (attributeType == 'primary' && !isSection) {
                objProperty = scope.property;
            }
            else {  //  secondary attributes
                objProperty = scope.property.attributes;
            }
            try {
                dataType = typeof eval(objProperty[key]);
            }
            catch (e) { }
            if (dataType == undefined) {
                dataType = typeof eval('scope.parentScope.' + objProperty[key]);
                if (dataType == 'function') {
                    str = attr + '="' + (bindingType == '@' ? '{{' : '') + this.generateFunctionWithParams(objProperty[key], 'parentScope', isSection) + (bindingType == '@' ? '}}' : '') + '"';
                }
                else {
                    str = attr + '="' + (bindingType == '@' ? '{{' : '') + 'parentScope.' + (objProperty[key]) + (bindingType == '@' ? '}}' : '') + '"';
                }
            }
            return ' ' + str + ' ';
        };

        /*
         *  Map attribute and its value
         */
        this.getAttributesMapping = function (attributeType, attrs, scope, isSection) {
            var str = '';
            if (attributeType == 'primary') {
                for (var key in attrs) {
                    switch (key) {
                        case 'isMandatory':
                            str += this.convertAndGetAttributeMapping(attributeType, key, 'is-mandatory', '@', scope, isSection);
                            break;
                        case 'isVisible':
                            str += this.convertAndGetAttributeMapping(attributeType, key, 'is-visible', '=', scope, isSection);
                            break;
                        case 'isCollapsible':
                            str += this.convertAndGetAttributeMapping(attributeType, key, 'is-collapsible', '@', scope, isSection);
                            break;
                        case 'isDraggable':
                            str += this.convertAndGetAttributeMapping(attributeType, key, 'is-draggable', '@', scope, isSection);
                            break;
                        case 'isActive':
                            str += this.convertAndGetAttributeMapping(attributeType, key, 'is-active', '=', scope, isSection);
                            break;
                        case 'isHeader':
                            str += this.convertAndGetAttributeMapping(attributeType, key, 'is-header', '@', scope, isSection);
                            break;
                        case 'headerTemplate':
                            str += ' ' + 'header-template="{{section.' + key + '}}" ';
                            break;
                        case 'modelOptions':
                            str += this.convertAndGetAttributeMapping(attributeType, key, 'model-options', '=', scope, isSection);
                            break;
                            //case 'focus':
                            //case 'validate':
                            //    str += this.convertAndGetAttributeMapping(attributeType, key, key, '=', scope, isSection);
                            //    break;
                        case 'rules':
                            str += this.convertAndGetAttributeMapping(attributeType, key, 'rules', '@', scope, isSection);
                            break;
                        case 'errorModel':
                            str += this.convertAndGetAttributeMapping(attributeType, key, 'error-model', '=', scope, isSection);
                            break;
                        case 'clienterror':
                            str += this.convertAndGetAttributeMapping(attributeType, key, 'clienterror', '=', scope, isSection);
                            break;
                        case 'currencySymbol':
                            str += this.convertAndGetAttributeMapping(attributeType, key, 'currency-symbol', '=', scope, isSection);
                            break;
                    }
                }
            }
            else {
                for (var key in attrs) {
                    switch (key) {
                        case 'type':
                            if (scope.property.type == 'textfield') {
                                var textfieldTypes = ['text', 'number', 'date', 'time', 'dateTime', 'area', 'autocomplete'];
                                if (textfieldTypes.indexOf(scope.property.attributes.type) == -1) {
                                    var arrSplitFunction = scope.property.attributes.type.split('(');
                                    var evalResult;
                                    var property = scope.property;  //  Property is element's config
                                    //  If function call is passed
                                    if (arrSplitFunction.length > 1) {
                                        evalResult = eval('scope.' + this.generateFunctionWithParams(scope.property.attributes.type, 'parentScope'));
                                    }
                                    else {
                                        evalResult = eval('scope.parentScope.' + scope.property.attributes.type);
                                        //  If function reference is passed
                                        if (typeof evalResult == 'function') {
                                            evalResult = eval('scope.' + this.generateFunctionWithParams(scope.property.attributes.type, 'parentScope'));
                                        }
                                    }
                                    str += ' type="' + evalResult + '"';
                                }
                                else {
                                    str += ' type="{{property.attributes.type}}" ';
                                }
                            }
                            break;
                        case 'options':
                            /*
                             *  Check if type of value passed is string. If yes convert the same into controller scope variable.
                             *  So that when the scope variable's value gets changed, the same would be reflected in directive.
                             */
                            if (typeof eval('scope.property.attributes.options') == 'string') {
                                str += ' options="parentScope.' + scope.property.attributes.options + '" ';
                            }
                            else {
                                str += ' options="property.attributes.options" ';
                            }
                            break;
                        case 'readonly':
                        case 'disable':
                        case 'infinite':
                            str += this.convertAndGetAttributeMapping(attributeType, key, key, '@', scope, isSection);
                            break;
                        case 'ngModelOptions':
                            str += ' ng-model-options="property.attributes.ngModelOptions" ';
                            break;
                        case 'validateOn':
                            str += ' validate-on="{{property.attributes.validateOn}}" ';
                            break;
                        case 'regionalformat':
                            str += ' regional-format="{{property.attributes.regionalformat}}" ';
                            break;
                        default:
                            var attrList = [];
                            if (scope.property.type == 'textfield') {
                                attrList = ['id', 'validate', 'focus', 'parentelement', 'errormessage', 'setfromgrid', 'align', 'datanumeric', 'spinner', 'patternreg', 'step', 'format', 'timepicker', 'isvaluedateobj', 'prefixicon', 'suffixicon', 'maxlength', 'min', 'max', 'timepicker12hour', 'minuteincrement', 'charactercounter', 'decimalprecision', 'minmaxprecision', 'placeholder', 'autocomplete', 'removable', 'datakey', 'filterkeys', 'optionformat', 'displayformat', 'width', 'minchars', 'loading', 'count', 'nosuggestionnotice', 'shownosuggestion', 'ngmodel', 'smart-character-restrict', 'showinfo', 'showwarning', 'allowpaste','validationreg'];
                            }
                            else if (scope.property.type == 'select' || scope.property.type == 'dropdown') {
                                attrList = ['id', 'label', 'ngmodelcopy', 'validate', 'focus', 'parentelement', 'multiple', 'datakey', 'displaykey', 'removable', 'preview', 'customoption', 'ngmodel', 'config', 'show', 'stopprog', 'showinfo', 'showwarning','showincidenticon'];
                            }
                            else if (scope.property.type == 'radio') {
                                attrList = ['id', 'label', 'ngmodelcopy', 'layout', 'validate', 'focus', 'parentelement', 'errormessage', 'datakey', 'optionid', 'removable', 'groupid', 'ngmodel'];
                            }
                            else if (scope.property.type == 'checkbox') {
                                attrList = ['id', 'label', 'minheight', 'fill', 'validate', 'focus', 'parentelement', 'errormessage',  'removable', 'ngmodel', 'showinfo'];
                            }
                            else if (scope.property.type == 'switch') {
                                attrList = ['id', 'label', 'rightlabel', 'leftlabel', 'validate', 'focus', 'parentelement', 'errormessage', 'removable', 'minheight', 'fill', 'ngmodel'];
                            }
                            
                            if (attrList.indexOf(key.toLowerCase()) > -1) {
                                str += ' ' + key + '="{{property.attributes.' + key + '}}" ';
                            }
                            break;
                    }
                }
            }
            return str;
        };


        /*
         *  Alternative of broadcast event
         */
        var arrEvents = [];
        var eventCounter = 0;

         
         /*
         *  Get broadcast event or events
         */
        this.getEventListener = function (event) {
            var eventLen = arrEvents.length;
            var listEvent=[];
            for (var i = 0; i < eventLen; i++) {
                var tObj = arrEvents[i];
                if (tObj.eventName == event) {
                   listEvent.push(tObj);
                }
            }
            return listEvent;
        };
        /*
         *  Deregister an event or events
         */
        this.removeEventListener = function (event) {
            var eventLen = arrEvents.length;
            for (var i = 0; i < eventLen; i++) {
                var tObj = arrEvents[i];
                if (tObj.eventName == event.eventName && tObj.eventId == event.eventId) {
                    tObj.callback = null;
                    arrEvents.splice(i, 1);
                    break;
                }
            }
        };


        /*
         *  Register a listener
         */
        this.on = function (eventName, callback) {
            eventCounter++;
            arrEvents.push({
                eventName: eventName,
                callback: callback,
                eventId: 'smart-broadcast-event-' + eventCounter
            });
            var objEvent = {
                eventName: eventName,
                eventId: 'smart-broadcast-event-' + eventCounter
            };
            return function () {
                _this.removeEventListener(objEvent);
            };
        };


        /*
         *  Fire an event
         */
        this.broadcast = function (eventName, data) {
            var broadcastEvLen = arrEvents.length;
            for (var i = 0; i < broadcastEvLen; i++) {
                var tData = arrEvents[i];
                if (eventName == tData.eventName) {
                    angular.isFunction(tData.callback) && tData.callback({}, data);
                }
            }
        };


        this.getMandatoryFieldHtml = function (isMandatory, scope, showOnlyAsterisk) {
            var tmpVal = (isMandatory || (showOnlyAsterisk && showOnlyAsterisk.toLowerCase() != 'false') ? true : false)
            if (typeof isMandatory == 'string') {
                if (isMandatory.indexOf('$root') > -1) {
                    tmpVal = eval('scope.' + isMandatory);
                }
                else {
                    tmpVal = eval(isMandatory);
                }
            }
            return tmpVal ? '<span class="mandatoryAsterisk">*</span>' : '';
        };



        /*
         *  Custom javascript watcher 
         */
        this.watch = function (obj, prop, callback) {
            Object.defineProperty(angular.isDefined(obj) && angular.isObject(obj) ? obj : window, prop, {
                get: function () {
                    return this['custom_watcher_' + prop];
                },
                set: function (newVal) {
                    if (!angular.equals(this['custom_watcher_' + prop], newVal)) {
                        var oldVal = this['custom_watcher_' + prop];
                        this['custom_watcher_' + prop] = newVal;
                        angular.isFunction(callback) && callback(newVal, oldVal);
                    }
                },
                enumerable: true,
                configurable: true
            });
        };


        /*
         *  Show PLEASE WAIT label
         */
        this.showPleaseWait = function () {
            angular.element('#divPleaseWait').css('display', 'table');
        };


        /*
         *  Hide PLEASE WAIT label
         */
        this.hidePleaseWait = function () {
            angular.element('#divPleaseWait').css('display', 'none');
        };
    }]);
})();
